import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "./RieInfoCard.module.css";

const RieInfoCard = ({ item, compact = false }) => {
  const Icon = item.icon;
  const className = compact ? `${styles.rieCard} ${styles.compact}` : styles.rieCard;

  return (
    <Box className={className}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {/*<Icon sx={{ fontSize: compact ? 18 : 22, color: "#13a89e" }} />*/}
        <Typography variant="h6" className={styles.rieTitle}>
          {item.title}
        </Typography>
      </Box>
      <Typography className={styles.rieTagline}>{item.tagline}</Typography>
      <Typography variant="body2" className={styles.rieDesc}>
        {item.desc}
      </Typography>
    </Box>
  );
};

export default RieInfoCard;
